__turbopack_context__.v({
  "container": "LbNOWq_container",
  "controls--left": "LbNOWq_controls--left",
  "flag": "LbNOWq_flag",
  "list": "LbNOWq_list",
  "size--sm": "LbNOWq_size--sm",
  "textIcon": "LbNOWq_textIcon",
  "variant--fiery": "LbNOWq_variant--fiery",
  "variant--gameChanger": "LbNOWq_variant--gameChanger",
  "variant--new": "LbNOWq_variant--new",
  "variant--salt": "LbNOWq_variant--salt",
});
